"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DELETE_CUSTOMER_PROFILE = "\nmutation DeleteProfile($id: ID!) {\n    deleteProfile(id: $id)\n}\n";
exports.default = DELETE_CUSTOMER_PROFILE;
//# sourceMappingURL=deleteCustomerProfile.js.map